<script setup>
import _ from "lodash";

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => {
      return ['keywordIdeas', 'rankedKeywords', 'competitorKeywords', 'aiGenerated'].includes(value);
    }
  },
  source: {
    type: [Object, Array, Number],
    required: false,
    default: null,
  },
});

const keywordIdeasTooltip = () => {
  let tooltip = `This suggestion was found using ${props.source.length > 1 ? 'these keyword ideas' : 'this keyword idea'}:<br>`;

  _.forEach(props.source, (source) => {
    tooltip += `- <strong>${source}</strong><br>`;
  });

  return tooltip;
}

const competitorKeywordsTooltip = () => {
  let tooltip = 'Your competitors rank for this keyword:<br>';

  _.forEach(props.source, (source) => {
    tooltip += `- <strong>${source.simple_url}</strong> rank at <strong>position ${source.position}</strong><br>`;
  });

  return tooltip;
}

const rankedKeywordsTooltip = () => {
  // Backwards compatibility for when the ranked keyword was just a ranking position
  const isNumber = Number.isInteger(props.source)
  const position = isNumber ? props.source : props.source.position;

  let string = `You currently rank in <strong>position ${position}</strong>`

  if (!isNumber) {
    const url = new URL(props.source.url);
    string += ` for the page <strong>${url.pathname}</strong>`;
  }

  return `${string} for this keyword`;
}

const types = {
  keywordIdeas: {
    name: 'Keyword Ideas',
    classes: 'tw-bg-keywordIdeasSources-bg-keywordIdeas tw-text-keywordIdeasSources-text-keywordIdeas',
    tooltip: keywordIdeasTooltip
  },
  rankedKeywords: {
    name: 'Ranked Keywords',
    classes: 'tw-bg-keywordIdeasSources-bg-rankedKeywords tw-text-keywordIdeasSources-text-rankedKeywords',
    tooltip: rankedKeywordsTooltip
  },
  competitorKeywords: {
    name: 'Competitor Keywords',
    classes: 'tw-bg-keywordIdeasSources-bg-competitorKeywords tw-text-keywordIdeasSources-text-competitorKeywords',
    tooltip: competitorKeywordsTooltip
  },
  aiGenerated: {
    name: 'AI Generated',
    classes: 'tw-bg-keywordIdeasSources-bg-aiGenerated tw-text-keywordIdeasSources-text-aiGenerated',
    tooltip: () => 'This suggestion was generated by AI',
  },
}
</script>

<template>
  <div
    :title="types[props.type].tooltip()"
    class="tw-px-2 tw-py-1 tw-rounded-md tooltipster tw-text-xxs"
    :class="types[type].classes"
  >
    {{ types[props.type].name }}
  </div>
</template>
